{
  "Untitled event": "Naamloos evenement",
  "Under a minute": "Minder dan een minuut",
  "{minutes} min": "{minutes} min",
  "{hours} h {minutes} min": "{hours} u {minutes} min",
  "{hours} h": "{hours} u",
  "Under 1 MB": "Minder dan 1 MB",
  "{count} part": {
    "one": "{count} deel",
    "other": "{count} delen"
  },
  "{count} recording": {
    "one": "{count} opname",
    "other": "{count} opnames"
  },
  "data file|Event details": "Evenementgegevens",
  "Every event's title, date, place, link and settings": "Titel, datum, locatie, link en instellingen van elk evenement",
  "Guests and registrations": "Gasten en registraties",
  "Names, emails, how each guest joined and what they watched": "Namen, e-mailadressen, hoe elke gast toegang kreeg en wat ze hebben bekeken",
  "Guestbook messages": "Gastenboekberichten",
  "Every message with its event, name and time": "Elk bericht met het evenement, de naam en het tijdstip",
  "Viewer counts": "Aantallen kijkers",
  "Live and replay viewers for each recording": "Live kijkers en terugkijkers per opname",
  "Sales and donations": "Verkopen en donaties",
  "Tickets, paid downloads and donations, with amounts and dates": "Tickets, betaalde downloads en donaties, met bedragen en datums",
  "This recording belongs to another account.": "Deze opname hoort bij een ander account.",
  "We couldn't find this recording. It may have been deleted.": "We konden deze opname niet vinden. Misschien is die verwijderd.",
  "Downloads are temporarily unavailable. Please try again in a few minutes.": "Downloaden is tijdelijk niet mogelijk. Probeer het over een paar minuten opnieuw.",
  "Could not reach EventLive. Check your internet connection and try again.": "EventLive is niet bereikbaar. Controleer je internetverbinding en probeer het opnieuw.",
  "Ready to download": "Klaar om te downloaden",
  "{count} recording is being prepared": {
    "one": "{count} opname wordt voorbereid",
    "other": "{count} opnames worden voorbereid"
  },
  "Download this one when one of them is ready.": "Download deze opname zodra een van de andere klaar is.",
  "Could not load your recordings.": "Je opnames konden niet worden geladen.",
  "Couldn't download the file": "Het bestand kon niet worden gedownload",
  "Still preparing. Long recordings take a while; you can leave this page and come back.": "Nog bezig met voorbereiden. Lange opnames duren even; je kunt deze pagina verlaten en later terugkomen.",
  "Joining {parts} parts into one MP4. This usually takes a few minutes.": "{parts} delen worden samengevoegd tot één MP4. Dit duurt meestal een paar minuten.",
  "Preparing the MP4. This usually takes a few minutes.": "De MP4 wordt voorbereid. Dit duurt meestal een paar minuten.",
  "This is taking much longer than usual. Try again, or contact support.": "Dit duurt veel langer dan normaal. Probeer het opnieuw of neem contact op met support.",
  "Couldn't prepare the download. Try again.": "De download kon niet worden voorbereid. Probeer het opnieuw.",
  "In the Secure Archive, so it can't be downloaded. Restore it to download it again, or delete it.": "Staat in het beveiligde archief, dus downloaden kan niet. Herstel de opname om weer te downloaden, of verwijder de opname.",
  "In the Secure Archive, so it can't be downloaded. You can delete it.": "Staat in het beveiligde archief, dus downloaden kan niet. Je kunt de opname verwijderen.",
  "Restore {title}": "{title} herstellen",
  "Delete {title}": "{title} verwijderen",
  "Download": "Downloaden",
  "Preparing…": "Voorbereiden…",
  "Preparing {title}": "{title} wordt voorbereid",
  "Try again: {title}": "Opnieuw proberen: {title}",
  "Download {title}": "{title} downloaden",
  "Guestbook PDF · {count} message": {
    "one": "Gastenboek-PDF · {count} bericht",
    "other": "Gastenboek-PDF · {count} berichten"
  },
  "Download the guestbook of {title} as a PDF": "Het gastenboek van {title} als PDF downloaden",
  "Download {title} (CSV)": "{title} downloaden (CSV)",
  "Deleted": "Verwijderd",
  "Couldn't delete it": "Verwijderen mislukt",
  "Delete “{title}”?": "“{title}” verwijderen?",
  "The event, its recording, guest list and guestbook are deleted for good. This can't be undone.": "Het evenement, de opname, de gastenlijst en het gastenboek worden definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",
  "Delete event": "Evenement verwijderen",
  "Loading your recordings…": "Je opnames laden…",
  "one MP4 file each": "één MP4-bestand per opname",
  "loading more…": "meer laden…",
  "Download everything": "Alles downloaden",
  "Your recordings are yours. Download any of them, any time, free.": "Je opnames zijn van jou. Download elke opname wanneer je maar wilt, gratis.",
  "Give a family or a couple their video, or keep your own archive.": "Geef een familie of een bruidspaar hun video, of bewaar je eigen archief.",
  "Download everything is for business accounts. To download a video, open its event and choose Download & View Stats.": "Alles downloaden is er voor zakelijke accounts. Wil je een video downloaden? Open dan het evenement en kies Downloaden en statistieken bekijken.",
  "Recordings": "Opnames",
  "Couldn't load your recordings": "Je opnames konden niet worden geladen",
  "No recordings yet": "Nog geen opnames",
  "When you stream an event or upload a video, it shows up here, ready to download.": "Als je een evenement streamt of een video uploadt, verschijnt die hier, klaar om te downloaden.",
  "Search for a recording": "Een opname zoeken",
  "Search recordings by title, place or date": "Zoek opnames op titel, locatie of datum",
  "Clear search": "Zoekopdracht wissen",
  "No recordings match “{query}”.": "Geen opnames gevonden voor “{query}”.",
  "Show {count} more": "Nog {count} tonen",
  "{count} recording found.": {
    "one": "{count} opname gevonden.",
    "other": "{count} opnames gevonden."
  },
  "Each MP4 joins every live session and upload in order, in the best quality we keep.": "Elke MP4 voegt alle livesessies en uploads op volgorde samen, in de beste kwaliteit die we bewaren.",
  "Long recordings are big files, so use a fast connection.": "Lange opnames zijn grote bestanden, dus gebruik een snelle verbinding.",
  "It opens in your browser to save. Long recordings are big files: a computer on Wi-Fi is quickest.": "Het bestand opent in je browser om op te slaan. Lange opnames zijn grote bestanden: een computer met Wi-Fi is het snelst.",
  "Your data": "Je gegevens",
  "Spreadsheets for Excel, Numbers or Google Sheets, covering every event in your account": "Spreadsheets voor Excel, Numbers of Google Sheets, met alle evenementen in je account",
  "One page with your events that anyone with the link can watch, and your ticketed events, newest first.": "Eén pagina met je evenementen die iedereen met de link kan bekijken, en je evenementen met tickets, nieuwste eerst.",
  "Your Video Wall link": "Link naar je Videomuur",
  "Video Wall link": "Link naar de Videomuur",
  "Copy Video Wall link": "Link naar de Videomuur kopiëren",
  "Open Video Wall": "Videomuur openen",
  "Embed on your website": "Embed op je website",
  "Paste the code into your website's HTML or embed block.": "Plak de code in de HTML van je website of in een embedblok.",
  "Code type": "Soort code",
  "Script (recommended)": "Script (aanbevolen)",
  "The wall grows to fit all your events instead of scrolling inside a box.": "De muur wordt zo groot als nodig voor al je evenementen, in plaats van te scrollen binnen een kader.",
  "Simple iframe (no script)": "Eenvoudig iframe (zonder script)",
  "For site builders that remove scripts. The wall scrolls inside the space your page gives it.": "Voor websitebouwers die scripts verwijderen. De muur scrolt binnen de ruimte die je pagina hem geeft.",
  "Copy embed code": "Embedcode kopiëren",
  "Embed code copied": "Embedcode gekopieerd",
  "Paste it into your website's HTML.": "Plak de code in de HTML van je website."
}
